import { Button } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { UnstyledLink } from '@hcr/pwa/components'

import { Path } from '../../../../models'
import { to } from '../../../../utils'
import { BookingDatesLoading, LayoutBookingOverview, LayoutBookingOverviewContent } from '../common'

export const BookingOverviewCompactLoading: FC = () => {
  const { t } = useTranslation()

  return (
    <LayoutBookingOverview>
      <LayoutBookingOverviewContent>
        <BookingDatesLoading />
        <Button component={UnstyledLink} to={to(Path.Booking)} variant='contained' color='primary'>
          {t('booking-overview.booking-and-program')}
        </Button>
      </LayoutBookingOverviewContent>
    </LayoutBookingOverview>
  )
}
